import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SelectFlujoEfectivo } from 'sharedComponents/select'

import { KeyEventUtil } from 'utils'

const FlujosEfectivoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('button-cajabancomodal-procesar', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FLUJO EFECTIVO' htmlFor='select-flujoEfectivo' md={12} />
      <Col md={12}>
        <Field name='flujoEfectivo'>
          {({ field }) => (
            <SelectFlujoEfectivo
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-flujoEfectivo'
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlujosEfectivoFormGroup)
